<top-banner variant="custom">
    <h2 class="title mb-3" *ngIf="selectedContractor">{{ selectedContractor.name }}</h2>
    <button type="button" (click)="toggleAddContactModal()" class="btn color_blue-btn btn-round">
      <i class="fas fa-plus"></i>
      &nbsp;
      <strong>ADD CONTACT</strong>
    </button>
</top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div class="col-md-10">
            <h4 class="card-title">Contacts</h4>
            <div class="mb-2 animated fadeIn">
              <!-- Table of results -->
              <div class="row">
                <div class="col-md-12">
                  <p-table [value]="contractorContacts" selectionMode="single" [(selection)]="selectedContact" (onRowSelect)="onRowSelect($event)">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Phone No.</th>
                        <th>Email</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-contact>
                      <tr [pSelectableRow]="contact">
                        <td>{{ contact.name }}</td>
                        <td>{{ contact.role }}</td>
                        <td>{{ contact.phone }}</td>
                        <td>{{ contact.email }}</td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="4">No contacts found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <p-paginator [alwaysShow]="false" [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Add Contractor Contact" [(visible)]="addContactModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="addContactForm" (ngSubmit)="onAddContractorContactFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" formControlName="name" placeholder="" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Role</label>
          <input type="text" class="form-control" formControlName="role" placeholder="" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Phone Number</label>
          <input type="text" class="form-control" formControlName="phone" placeholder="" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Email Address</label>
          <input type="text" class="form-control" formControlName="email" placeholder="" />
        </div>
      </div>
      <div class="col-md-12" *ngIf="errorAlerts">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="addContactModal = false" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onAddContractorContactFormSubmit()" [disabled]="!addContactForm.valid" class="my-2 btn btn-round btn-sm btn-success">Add Contact</button>
  </p-footer>
</p-dialog>

<p-dialog header="Edit Contact" [(visible)]="editContactModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="editContactForm" (ngSubmit)="onEditContactFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" formControlName="name" placeholder="" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Role</label>
          <input type="text" class="form-control" formControlName="role" placeholder="" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Phone Number</label>
          <input type="text" class="form-control" formControlName="phone" placeholder="" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Email Address</label>
          <input type="text" class="form-control" formControlName="email" placeholder="" />
        </div>
      </div>
      <div class="col-md-12">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="editContactModal = false" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onEditContactFormSubmit()" [disabled]="!editContactForm.valid" class="my-2 btn btn-round btn-sm btn-success">Save</button>
  </p-footer>
</p-dialog>
